export const ErreurConfig = [
    // Text
    {
        code:"MESS001", 
        text: "Veuillez renseigner le champs" 
    },
    //Checkbox
    {
        code:"MESS002", 
        text: "Veuillez cocher l'une des propositions" 
    },
    // Nombre
    {
        code:"MESS003", 
        text: "Veuillez saisir un nombre supérieur à 0" 
    },
    //Select
    {
        code:"MESS004", 
        text: "Veuillez sélectionner l'une des propositions" 
    },
    //Prix
    {
        code:"MESS005", 
        text: "Veuillez saisir un prix supérieur à 0" 
    },
    //Photo
    {
        code:"MESS006", 
        text: "Veuillez charger une photo" 
    },
    //Textarea
    {
        code:"MESS007", 
        text: "Veuillez saisir une description" 
    },
    {
        code:"MESS008", 
        text: "Veuillez saisir un mot de passe" 
    },
    {
        code:"MESS009", 
        text: "Veuillez saisir une adresse email valide." 
    },
    {
        code:"MESS010", 
        text: "Veuillez saisir un numéro de téléphone valide." 
    },
    {
        code:"MESS011", 
        text: "Veuillez ajouter au moins un niveau de formule." 
    },
    {
        code:"MESS012", 
        text: "Veuillez ajouter au moins un produit dans la sélection." 
    },
    // Password Same
    {
        code:"MESS013", 
        text: "Les mots de passe doivent être identifques." 
    }, 
    // Required password 
    {
        code:"MESS014", 
        text: "Veuillez corriger les erreurs suivantes:" 
    }
];
